var map = {
	"./a.png": "QCO9",
	"./b.png": "fvsO",
	"./c.png": "EMpt",
	"./d.png": "OqNj"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Nm5Q";


//////////////////
// WEBPACK FOOTER
// ./src/components/jeu2/img ^\.\/.*\.png$
// module id = Nm5Q
// module chunks = 0